import { render, staticRenderFns } from "./UploadTableStaff.vue?vue&type=template&id=a1bf3e56&"
import script from "./UploadTableStaff.vue?vue&type=script&lang=js&"
export * from "./UploadTableStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports